window.TeamLiveReportsAPI = new (function () {
    "use strict";

    var self = this;
    var _protected = BaseAPI.call(self);

    _protected.setApiUrl(publicConfiguration['TeamLiveReports']);

    self.getScheduleChangesPremiumBrandDetailsReport = function (groupId, params) {
        var defer = $q.defer();
        var url = 'brands/' + groupId + '/team_live/fww_premium/brands/' + groupId;

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getBrandActualLabors = function (brandId, fromDate, toDate, brandExcludeChildren) {
        var deferred = $q.defer();

        var params = {
            from_date: fromDate.format('YYYY-MM-DD'),
            to_date: toDate.format('YYYY-MM-DD')
        };

        if (brandExcludeChildren && brandExcludeChildren.length) {
            params['brand_ids_exclude_children'] = brandExcludeChildren;
        }

        _protected.request("brands/" + brandId + "/team_live/labor", 'GET', params)
            .then(function (data) {

                if (data && data.data && data.data.data && data.status === 200) {
                    deferred.resolve(data.data.data);
                } else {
                    deferred.reject(data);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandForecastedLabors = function (brandId, fromDate, toDate, brandExcludeChildren) {
        var deferred = $q.defer();

        var params = {
            from_date: fromDate.format('YYYY-MM-DD'),
            to_date: toDate.format('YYYY-MM-DD')
        };

        if (brandExcludeChildren && brandExcludeChildren.length) {
            params['brand_ids_exclude_children'] = brandExcludeChildren;
        }

        _protected.request("brands/" + brandId + "/team_live/labor/forecast", 'GET', params)
            .then(function (data) {

                if (data && data.data && data.data.data && data.status === 200) {
                    deferred.resolve(data.data.data);
                } else {
                    deferred.reject(data);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getScheduleChangesPremiumBrandSummaryReport = function (groupId, params) {
        var defer = $q.defer();
        var url = 'brands/' + groupId + '/team_live/fww_premium/brands/' + groupId + '/summary';

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.exportScheduleChangesPremiumReportToCSV = function(groupId, params){
        var defer = $q.defer();
        var url = 'brands/' + groupId + '/team_live/fww_premium/export';

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getWageSummaryReportByCategory = function (groupId, params) {
        var defer = $q.defer();
        var url = 'brands/' + groupId + '/team_live/wage/category_position';

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getUnscheduledEmployeeReportData = function (groupId, brandId, params) {
        var defer = $q.defer();
        var url = 'brands/' + groupId + '/team_live/unscheduled_employee/brands/' + brandId + '/report';

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getPayTypes = function (groupId, params) {
        var defer = $q.defer();
        var url = 'brands/' + groupId + '/team_live/pay_types';

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getWageTypes = function (groupId, params) {
        var defer = $q.defer();
        var url = 'brands/' + groupId + '/team_live/wage_types';

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getSettingCategory = function (groupId) {
        var defer = $q.defer();
        var url = 'brands/' + groupId + '/source_hire/compliance_settings/settings_category_filter';

        _protected.request(url, 'GET')
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getUpdatedByManagers = function (groupId) {
        var defer = $q.defer();
        var url = 'brands/' + groupId + '/source_hire/compliance_settings/updated_by_filter';

        _protected.request(url, 'GET')
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getBrandCategoriesAndPositions = function (groupId) {
        var defer = $q.defer();
        var url = 'brands/' + groupId + '/team_live/category_position';

        _protected.request(url, 'GET')
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getBrandCategoriesAndPositionsV2 = function (groupId) {
        var defer = $q.defer();
        var url = 'brands/' + groupId + '/team_live/v2/category_position';

        _protected.request(url, 'GET')
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getAdpCreatedByUsers = (groupId, brandId) => {
        const defer = $q.defer();
        const url = `brands/${groupId}/integrations/adp_sync_status/brand/${brandId}/created_by`;

        _protected.request(url, 'GET')
            .then((response) => {
                if (response?.status === 200) {
                    defer.resolve(response?.data?.data?.users || []);
                }
            })
            .catch((error) => {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.exportWageSummaryReport = function (groupId, params) {
        var defer = $q.defer();
        var url = 'brands/' + groupId + '/team_live/wage/export';

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getScheduleChangeReportSummaryReportData = function (groupId, brandId, params) {
        var defer = $q.defer();
        var url = 'brands/' + groupId + '/team_live/schedule/brands/' + brandId + '/schedule_change/summary';

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getGFEStatusFilterOptions = function (groupId, brandId, params) {
        var defer = $q.defer();
        var url = 'brands/' + groupId + '/team_live/schedule/brands/' + brandId + '/weekly_schedule/gfe_status_filter';

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            })
            .catch(function (error) {
                defer.reject(error);
            });

        return defer.promise;
    }

    self.getTimeSheetReport = function (groupId, params) {
        var defer = $q.defer();
        var url = 'brands/' + groupId + '/team_live/timesheet';

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getEmployeeTimeSheetSummary = function (groupId, employeeId, params) {
        var defer = $q.defer();
        var url = 'brands/' + groupId + '/team_live/timesheet/employees/' + employeeId;

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getTeamLiveEmployees = function (groupId, params) {
        var defer = $q.defer();
        var url = 'brands/' + groupId + '/team_live/employees';

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getTeamLiveGroupSettings = cacheService.cache(function (groupId) {
        var defer = $q.defer();
        var url = 'brands/' + groupId + '/team_live/brand_settings';

        _protected.request(url, 'GET')
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    })[0];



    self.exportTimeSheetDetailsReport = function (groupId, params) {
        var defer = $q.defer();
        var url = 'brands/' + groupId + '/team_live/timesheet/export';

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    // Scheduling Status Report

    self.getSchedulingStatusReport = function (groupId, brandId, params) {
        var deferred = $q.defer();
        var url = 'brands/'+ groupId +'/team_live/scheduling_status/brands/'+ brandId;
        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    deferred.resolve(response.data.data);
                }
            }, function (error) {
                deferred.reject(error);
            });
        return deferred.promise;
    };

    self.exportSchedulingStatusReportToCSV = function (groupId, params) {
        var deferred = $q.defer();
        var url = 'brands/' + groupId + '/team_live/scheduling_status/export';
        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    deferred.resolve(response.data);
                }
            }, function (error) {
                deferred.reject(error);
            });
        return deferred.promise;
    };

    // holiday allowance

    self.getHolidayAllowanceHolidayYears = function (groupId) {
        var deferred = $q.defer();
        var url = 'brands/'+ groupId +'/team_live/holiday_allowance/holiday_years';
        _protected.request(url, 'GET')
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    deferred.resolve(response.data.data);
                }
            }, function (error) {
                deferred.reject(error);
            });
        return deferred.promise;
    };

    self.getHolidayAllowanceReportStats = function (groupId, brandId, params) {
        var deferred = $q.defer();
        var url = 'brands/'+ groupId +'/team_live/holiday_allowance/brands/'+ brandId;
        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    deferred.resolve(response.data.data);
                }
            }, function (error) {
                deferred.reject(error);
            });
        return deferred.promise;
    };

    self.getHolidayAllowanceReportUserPlans = function (groupId, brandId, params) {
        var deferred = $q.defer();
        var url = 'brands/'+ groupId +'/team_live/holiday_allowance/brands/'+ brandId + '/employees';
        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    deferred.resolve(response.data.data);
                }
            }, function (error) {
                deferred.reject(error);
            });
        return deferred.promise;
    };

    self.exportHolidayAllowanceReportReportToCSV = function(groupId, params){
        var defer = $q.defer();
        var url = 'brands/' + groupId + '/team_live/holiday_allowance/export';

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };



    //employee-health-check-report

    self.getHealthCheckReportSummarizedByChecks = function (groupId, brand_id, params) {
        var defer = $q.defer();
        var url = 'v2/brands/' + groupId + '/team_live/health_check/brands/' + brand_id + '/checks_summary';
        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    //needed-hours-report

    self.getNeededHoursReportData = function (groupId, brand_id, params) {
        var defer = $q.defer();

        var url = 'brands/' + groupId + '/team_live/needed_hours/brands/' + brand_id + '/activity';

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.exportNeededHoursReport = function (groupId, brand_id, params) {

        var defer = $q.defer();
        var url = 'brands/' + groupId + '/team_live/needed_hours/brands/' + brand_id + '/export';

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getHealthCheckReportSummarizedByEmployees = function (groupId, brand_id, params) {
        var defer = $q.defer();
        var url = 'v2/brands/' + groupId + '/team_live/health_check/brands/' + brand_id + '/employees_summary';
        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getHealthCheckEmployeesReport = function (groupId, brand_id, params) {
        var defer = $q.defer();
        var url = 'v2/brands/' + groupId + '/team_live/health_check/brands/' + brand_id;
        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getHealthCheckDetailedReport = function (groupId, brand_id, user_id,  params) {
        var defer = $q.defer();
        var url = 'v2/brands/' + groupId + '/team_live/health_check/brands/' + brand_id + '/users/' + user_id;
        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.exportHealthCheckReportToCSV = function(groupId, params){
        var defer = $q.defer();
        var url = 'v2/brands/' + groupId + '/team_live/health_check/export';

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };



    // Absence Tracker Report

    self.getBrandAbsencesReportData = function (groupId, brand_id, params) {
        var defer = $q.defer();
        var url = 'brands/' + groupId + '/team_live/absences/brands/' + brand_id + '/brand';

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getAbsencesReportEmployeesData = function (groupId, brand_id, params) {
        var defer = $q.defer();
        var url = 'brands/' + groupId + '/team_live/absences/brands/' + brand_id + '/employees';

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.exportAbsenceTrackerReport = function (groupId, brand_id, params) {

        var defer = $q.defer();
        var url = 'brands/' + groupId + '/team_live/absences/brands/' + brand_id + '/export';

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data);
                }
                else {
                    defer.reject(response);
                }
            })
            .catch(function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getBiometricLoginLocations = function (groupId, brandId, params) {
        const defer = $q.defer();
        const url = `brands/${groupId}/source_hire/biometric_consent/brand/${brandId}/login_locations`;

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getBreakWaiverLoginLocations = function (groupId, brandId, params) {
        const defer = $q.defer();
        const url = `brands/${groupId}/source_hire/break_waiver_consent/brand/${brandId}/login_locations`;

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    // Flash Dash Report

    self.getFlashDashReportData = function (groupId, brand_id, params) {
        var defer = $q.defer();
        var url = 'brands/' + groupId + '/team_live/flash_dash/v2/brands/' + brand_id;

          _protected.request(url, 'GET', params)
              .then(function (response) {
                  if (response.data && response.status === 200) {
                      defer.resolve(response.data.data);
                  }
              }, function (error) {
                  defer.reject(error);
              });

        return defer.promise;
    };

    self.getFlashDashReportDailyData = function (groupId, brand_id, params) {
        var defer = $q.defer();
        var url = 'brands/' + groupId + '/team_live/flash_dash/v2/brands/' + brand_id + '/days';

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    // Operational Flash Dash Report

    self.getOperationalFlashDashReportData = function (groupId, tree_id, params) {
        var defer = $q.defer();
        var url = 'brands/' + groupId + '/team_live/operational_flash_dash/v2/trees/' + tree_id;

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getOperationalFlashDashReportLeafData = function (groupId, tree_id, node_id, params) {
        var defer = $q.defer();
        var url = 'brands/' + groupId + '/team_live/operational_flash_dash/v2/trees/' + tree_id + '/nodes/' + node_id;

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getOperationalFlashDashReportDailyData = function (groupId, tree_id, params) {
        var defer = $q.defer();
        var url = 'brands/' + groupId + '/team_live/operational_flash_dash/v2/trees/' + tree_id + '/days';

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getBrandConversationHistoryReportData = function (groupId, params) {
        var defer = $q.defer();
        var url = 'brands/' + groupId + '/source_hire/conversation';

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });
        return defer.promise;
    };

    self.getConversationHistoryReportMessagesData = function (groupId, conversationId, params) {
        var defer = $q.defer();
        var url = 'brands/' + groupId + '/source_hire/conversation/messages/' + conversationId;

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.exportConversationHistoryReport = function (groupId, params) {
        var defer = $q.defer();
        var url = 'brands/' + groupId + '/source_hire/conversation/export';

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getContactInfoData = function (groupId) {
        var defer = $q.defer();
        
        var url = 'brands/' + groupId + '/source_hire/conversation/conversation_user_info';

        _protected.request(url, 'GET')
            .then( function(response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    // Schedule Audit Report

    self.getScheduleAuditSummaryReport = function (groupId, brandId, params) {
        var deferred = $q.defer();
        var url = 'brands/'+ groupId +'/team_live/schedule_audit/brands/'+ brandId + '/summary';
        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    deferred.resolve(response.data.data);
                }
            }, function (error) {
                deferred.reject(error);
            });
        return deferred.promise;
    };

    self.getScheduleAuditReport = function (groupId, brandId, params) {
        var deferred = $q.defer();
        var url = 'brands/'+ groupId +'/team_live/schedule_audit/brands/'+ brandId;
        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    deferred.resolve(response.data.data);
                }
            }, function (error) {
                deferred.reject(error);
            });
        return deferred.promise;
    };

    self.exportScheduleAuditReportToCSV = function(groupId, params){
        var defer = $q.defer();
        var url = 'brands/' + groupId + '/team_live/schedule_audit/export';

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };


    // labor-analysis-report

    self.getLaborAnalysisReport = function (groupId, brandId,   params) {
        var defer = $q.defer();

        var url = 'brands/' + groupId + '/team_live/lab/brands/' + brandId + '/lab';
        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getTimeChangeApprovalReport = function (groupId, brandId, params) {
        var defer = $q.defer();

        var url = 'brands/' + groupId + '/team_live/punches/brands/' + brandId + '/approval';
        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    }

    //McD Time Punch Summary

    self.getPunchSummaryReportData = function (groupId, brand_id, params) {
        var defer = $q.defer();

        var url = 'brands/' + groupId + '/team_live/punches/brands/' + brand_id + '/summary';

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    //full-punch-detail-report

    self.getFullPunchDetailReport = function (groupId, brandId, params) {
        var defer = $q.defer();
        var url = 'brands/' + groupId + '/team_live/punches/brands/' + brandId + '/details';
        _protected.request(url, 'GET', params)
            .then( function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
               defer.reject(error);
            });
        return defer.promise;
    };

    // scheduled-breaks-report

    self.getScheduledBreaksReportByEmployee = function (groupId, brandId, params) {
        const defer = $q.defer();
        const url = `brands/${groupId}/team_live/breaks/brands/${brandId}/employee`;

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getScheduledBreaksReportByLocation = function (groupId,  params, brandId) {
        var defer = $q.defer();
        var url = 'brands/' + groupId + '/team_live/breaks/brands/' + brandId;
        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };


    self.exportScheduledBreaksReport = function (groupId,  params) {
        var defer = $q.defer();
        var url = 'brands/' + groupId + '/team_live/breaks/export';
        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    // unassigned-published-shifts

    self.getUnassignedPublishedShiftsDetailedReport = function (groupId, brand_id, params) {
        var defer = $q.defer();
        var url = 'brands/' + groupId + '/team_live/available_shifts/brands/' + brand_id;
        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getUnassignedPublishedShiftsSummaryReport = function (groupId, brand_id, params) {
        var defer = $q.defer();
        var url = 'brands/' + groupId + '/team_live/available_shifts/brands/' + brand_id + '/summary';
        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.exportUnassignedPublishedShiftsReport = function (groupId, params) {
        var defer = $q.defer();
        var url = 'brands/' + groupId + '/team_live/available_shifts/export';

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    // employee satisfaction

    self.getEmployeesDetailedSatisfactionSummaryReport = function (groupId, brandId, params) {
        if (!groupId) {
            throw new Error("Group id is required, got: " + groupId);
        }

        var deferred = $q.defer();
        var url = 'brands/' + groupId + '/team_live/detailed_employee_satisfaction/brands/' + brandId + '/summary';
        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    deferred.resolve(response.data.data);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;

    };

    self.getEmployeesDetailedSatisfactionReport = function (groupId, brandId, params) {
        if (!groupId) {
            throw new Error("Group id is required, got: " + groupId);
        }

        var deferred = $q.defer();
        var url = 'brands/' + groupId + '/team_live/detailed_employee_satisfaction/brands/' + brandId;
        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    deferred.resolve(response.data.data);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;

    };
    self.exportEmployeesDetailedSatisfactionReportToCSV = function (groupId, params) {
        if (!groupId) {
            throw new Error("Group id is required, got: " + groupId);
        }

        var deferred = $q.defer();
        var url = 'brands/' + groupId + '/team_live/detailed_employee_satisfaction/export';
        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    deferred.resolve(response.data);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;

    };

    // Detailed Labor Report

    self.getDetailedLaborReportByBrand = function (groupId, brandId, params) {
        var deferred = $q.defer();
        var url = 'brands/'+ groupId +'/team_live/detailed_labor/brands/'+ brandId;
        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    deferred.resolve(response.data.data);
                }
            }, function (error) {
                deferred.reject(error);
            });
        return deferred.promise;
    };


    self.getDetailedLaborReportGroupedByCategory = function (groupId, params) {
        var deferred = $q.defer();
        var url = 'brands/'+ groupId +'/team_live/detailed_labor/categories';
        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    deferred.resolve(response.data.data);
                }
            }, function (error) {
                deferred.reject(error);
            });
        return deferred.promise;
    };

    self.getDetailedLaborEmployeesReport = function (groupId, params) {
        var deferred = $q.defer();
        var url = 'brands/'+ groupId +'/team_live/detailed_labor/employees';
        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    deferred.resolve(response.data.data);
                }
            }, function (error) {
                deferred.reject(error);
            });
        return deferred.promise;
    };

    self.exportDetailedLaborEmployeesReportToCSV = function (groupId, params) {
        var deferred = $q.defer();
        var url = 'brands/'+ groupId +'/team_live/detailed_labor/export';
        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    deferred.resolve(response.data);
                }
            }, function (error) {
                deferred.reject(error);
            });
        return deferred.promise;
    };

    // Availability

    self.getAvailabilityReport = function (groupId, brandId, params) {
        var deferred = $q.defer();
        var url = 'brands/'+ groupId +'/team_live/availability/brands/' + brandId + '/report';
        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    deferred.resolve(response.data.data);
                } else {
                    deferred.reject(response);
                }
            }, function (error) {
                deferred.reject(error);
            });
        return deferred.promise;
    }

    // Weekly Schedule Report

    self.getWeeklyScheduleReportData = function (groupId, brandId, params) {
        var deferred = $q.defer();
        var url = 'brands/'+ groupId +'/team_live/schedule/brands/' + brandId + '/weekly_schedule';
        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    deferred.resolve(response.data.data);
                } else {
                    deferred.reject(response);
                }
            }, function (error) {
                deferred.reject(error);
            });
        return deferred.promise;
    };

    // Forecast Accuracy Report

    self.getForecastAccuracyReportHourlyViewData = function (groupId, brandId, params) {
        var deferred = $q.defer();

        var url = 'brands/'+ groupId +'/team_live/forecast_accuracy/brands/' + brandId + '/hourly';
        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    deferred.resolve(response.data.data);
                } else {
                    deferred.reject(response);
                }
            }, function (error) {
                deferred.reject(error);
            });
        return deferred.promise;
    };

    self.getForecastAccuracyReportDayOfWeekViewData = function (groupId, brandId, params) {
        var deferred = $q.defer();
        var url = 'brands/'+ groupId +'/team_live/forecast_accuracy/brands/' + brandId + '/day_of_week';
        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    deferred.resolve(response.data.data);
                } else {
                    deferred.reject(response);
                }
            }, function (error) {
                deferred.reject(error);
            });
        return deferred.promise;
    };

    self.getForecastAccuracyReportDateViewData = function (groupId, brandId, params) {
        var deferred = $q.defer();
        var url = 'brands/'+ groupId +'/team_live/forecast_accuracy/brands/' + brandId + '/daily';
        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    deferred.resolve(response.data.data);
                } else {
                    deferred.reject(response);
                }
            }, function (error) {
                deferred.reject(error);
            });
        return deferred.promise;
    };

    // Labor Exception Report

    self.getLaborExceptionReportData = function (groupId, brandId, params) {
        var deferred = $q.defer();
        var url = 'brands/' + groupId + '/team_live/labour_exception/brands/' + brandId;
        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    deferred.resolve(response.data.data);
                } else {
                    deferred.reject(response);
                }
            }, function (error) {
                deferred.reject(error);
            });
        return deferred.promise;
    };

    // Labor Variance

    self.getLaborVarianceActualReport = function (groupId, params) {
        var deferred = $q.defer();
        var url = 'brands/'+ groupId +'/team_live/labor_variance/labor/actual';
        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    deferred.resolve(response.data.data);
                }
            }, function (error) {
                deferred.reject(error);
            });
        return deferred.promise;
    };

    self.getLaborVarianceForecastedReport = function (groupId, params) {
        var deferred = $q.defer();
        var url = 'brands/'+ groupId +'/team_live/labor_variance/labor/forecasted';
        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    deferred.resolve(response.data.data);
                }
            }, function (error) {
                deferred.reject(error);
            });
        return deferred.promise;
    };

    self.getLaborVarianceSalesReport = function (groupId, params) {
        var deferred = $q.defer();
        var url = 'brands/'+ groupId +'/team_live/labor_variance/sales';
        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    deferred.resolve(response.data.data);
                }
            }, function (error) {
                deferred.reject(error);
            });
        return deferred.promise;
    };

    self.getSalesDemandForecasting = function (groupId, params) {
        var deferred = $q.defer();
        var url = 'brands/'+ groupId +'/team_live/labor_variance/sales_forecast';
        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    deferred.resolve(response.data.data);
                }
            }, function (error) {
                deferred.reject(error);
            });
        return deferred.promise;
    };

    // Daily Activity Report

    self.getDailyActivityReport = function (groupId, brandId, params) {
        var deferred = $q.defer();
        var url = 'brands/' + groupId + '/team_live/dar/brands/' + brandId + '/activity';
        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    deferred.resolve(response.data.data);
                }
            }, function (error) {
                deferred.reject(error);
            });
        return deferred.promise;
    };

    self.exportDailyActivityReportToCSV = function (groupId, brandId, params) {
        var deferred = $q.defer();
        var url = 'brands/' + groupId + '/team_live/dar/brands/' + brandId + '/export';
        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    deferred.resolve(response.data);
                }
            }, function (error) {
                deferred.reject(error);
            });
        return deferred.promise;
    };

    self.getEmployeeRosterReport = function (groupId, brandId, params) {
        var deferred = $q.defer();
        var url = 'brands/'+ groupId +'/team_live/employee_roster/brands/' + brandId + '/report';
        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    deferred.resolve(response.data.data);
                } else {
                    deferred.reject(response);
                }
            }, function (error) {
                deferred.reject(error);
            });
        return deferred.promise;
    };

    self.getBrandJTCs = function (groupId) {
        var deferred = $q.defer();
        var url = 'brands/'+ groupId +'/team_live/employee_roster/jtcs';
        _protected.request(url, 'GET')
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    deferred.resolve(response.data.data);
                } else {
                    deferred.reject(response);
                }
            }, function (error) {
                deferred.reject(error);
            });
        return deferred.promise;
    };

    self.getDetailsScheduleChangeReportData = function (groupId, brandId, params) {

        var defer = $q.defer();
        var url = 'brands/'+ groupId +'/team_live/schedule/brands/'+ brandId + '/schedule_change/details';

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });
        return defer.promise;
    }


    self.getScheduleLocationUsers = function (groupId, brandId, params) {
        var defer = $q.defer();
        var url = 'brands/' + groupId + '/team_live/schedule/brands/' + brandId + '/location_user';

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });
        return defer.promise;
    }

    self.getCustomerUsers = function (groupId, brandId, params) {
        var defer = $q.defer();
        var url = 'brands/' + groupId + '/team_live/schedule/brands/' + brandId + '/customer_user';

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });
        return defer.promise;
    }

    self.getDailyCrewScheduleReportKPIs = function (groupId, brandId, params) {
        var defer = $q.defer();
        var url = 'brands/' + groupId + '/team_live/schedule/brands/' + brandId + '/daily_crew_schedule/kpis';

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            })
            .catch(function (error) {
                defer.reject(error);
            });

        return defer.promise;
    }
    self.getDailyCrewScheduleReportShiftsDetails = function (groupId, brandId, params) {
        var defer = $q.defer();
        var url = 'brands/' + groupId + '/team_live/schedule/brands/' + brandId + '/daily_crew_schedule/line_bar';

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            })
            .catch(function (error) {
                defer.reject(error);
            });

        return defer.promise;
    }


    self.getAttendanceReliabilityReportData = function (groupId, brandId, params) {
        var defer = $q.defer();
        var url = 'brands/' + groupId + '/team_live/attendance_reliability/brands/' + brandId;

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            })
            .catch(function (error) {
                defer.reject(error);
            });

        return defer.promise;
    }

    self.getUnemploymentClaimsEmployees = async (groupId, params) => {
        const url = `brands/${groupId}/team_live/unemployment_claims/employees`;
        const response = await _protected.request(url, 'GET', params);

        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }

        throw response;
    };


    self.getSchedulePublishHistoryApprovers = async (groupId, brandId) => {
        const url = `brands/${groupId}/team_live/schedule_history/managers/${brandId}`;
        const response = await _protected.request(url, 'GET');

        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }

        throw response;
    };

    self.getPayPeriodDetailsReportData = function (groupId, brandId, params) {
        var defer = $q.defer();
        var url = 'brands/' + groupId + '/team_live/pay_period/brands/' + brandId + '/employee';

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            })
            .catch(function (error) {
                defer.reject(error);
            });

        return defer.promise;
    }

    self.getPayPeriodTotalsReportData = function (groupId, brandId, params) {
        var defer = $q.defer();
        var url = 'brands/' + groupId + '/team_live/pay_period/brands/' + brandId + '/total';

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            })
            .catch(function (error) {
                defer.reject(error);
            });

        return defer.promise;
    }

    self.getCustomerTimezones = async (groupId) => {
        const url = `brands/${groupId}/source_hire/customer_timezone`;
        const response = await _protected.request(url, 'GET');

        if (response?.status === 200 && response?.data?.data) {
            const sources = response.data.data.sources;
            return sources.map(source => ({code: source.timezone, name: source.timezone}));
        }

        throw response;
    };

    self.getIntegrationRejectionReportData = function (groupId, brandId, params) {
        var defer = $q.defer();
        var url = 'brands/' + groupId + '/source_hire/integration_rejection/brands/' + brandId + '/mchire';

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            })
            .catch(function (error) {
                defer.reject(error);
            });

        return defer.promise;
    }

})();
